import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Mensaje, MensajeCapcha, MensajeSiNo } from '../components/mensajes';



import useTable from "../components/useTable"

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from "axios";
import { Dimmer } from '../components/spinner';


const headCells = [
    { id: 'login', label: 'LOGIN', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    { id: 'persona', label: 'CEDULA', width: '50px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    { id: 'nombres', label: 'NOMBRE', width: '300px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    { id: 'idusuario', label: 'ID USUARIO', width: '30px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
]

const CatalogoLiquidador = props => {

    /*  variables de estados */
    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);   
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.login.toLowerCase().includes(target.value.toLowerCase())
                            || x.cedula.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombres.toLowerCase().includes(target.value.toLowerCase())
                            || x.idusuario.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    /* metodo para restablecer los valores  a su estado inicial */

    const blanquear = () => {
        setActivo(true);
        setItemSelect("");
        setMostrar(false);
        setTitulo('');
        setMsg('');
        setMostrar1(false);
        setTitulo2('');
        setMsg2('');
        setActivate(false);
        setContar(0);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
        /*  */
    }



    /* metodo para cerrar el modal */

    const cancelar = () => {

        blanquear();
        //alert(login);
        props.onHideCancelaCatLiq();
    }

    const renderizar = () => {
        seleccionarLiquidadorTodos();
    }

    const seleccionarLiquidadorTodos = () => {
      //  setActivate(true);
        setContar4(0);
     //   datosLiquidador();
    };

    

    const selectOrden = () => {

        var login = values.login;
        var nomLiq = values.nomLiq;
        var idLiq = values.idLiq;
      console.log(login, nomLiq, idLiq)
        blanquear();
        props.onHideAceptaCatLiq(login, nomLiq, idLiq);
      
    };

    const seleccionarUnidadEjecutora = () => {
        setActivate(true);

        let endpoint = `${op.conexion}/api/catalogo/liquidadores`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {

                setActivate(false);
                var uni = []
              
                console.log(response.data)
                setRecords(response.data)
            }

        }).catch(function (error) {
            // setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setTitulo("Error");
            setMsg(error.response.data.message);
            setMostrar(true);
        }).finally(() => {
            setActivate(false);
        })
    }
console.log(values)
    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var login = recordsAfterPagingAndSorting()[index].login;
        var nomLiq = recordsAfterPagingAndSorting()[index].nombres;
        var idLiq = recordsAfterPagingAndSorting()[index].idusuario;
        
        setValues({
            login,
            nomLiq,
            idLiq
        })
        

    };
    
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarUnidadEjecutora()
            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Personas.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.cedula} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "200px", verticalAlign: "middle" }}>{item.login}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "50px", verticalAlign: "middle" }}>{item.cedula}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "300px", verticalAlign: "middle" }}>{item.nombres + ' ' + item.apellidos}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "30px", verticalAlign: "middle" }}>{item.idusuario}</td>

                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectOrden}><i className="fas fa-check-circle"> Aceptar</i> </button>

                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
               

            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoLiquidador;